<template >
    <div class="zoneMap" :id="mapName"></div>
</template>

<script>

    import store from '../../store';

    const GoogleMap = {
        name: 'ponroy-google-map',
        store,
        props: {
            'name': {
                required:true,
            },
            'lat': {
                required: true,
            },
            'lng': {
                required: true,
            },
            'markers' : {
                required: true,
            },
            'selectedMarker' : {
                required: false,
            },
            'storeSetColissimoPoint': {
                required: true,
                default: 'order/SET_COLISSIMO_POINT',
            },
        },
        data: function () {
            return {
                mapName: this.name + "Map",
                gMarkers: [],
                gMap: null,
                gMapInfoWindows: [],
            }
        },
        methods: {
            setMarkers() {
                let vm = this;
                this.deleteMarkers();
                const bounds = new google.maps.LatLngBounds();
                const map = this.gMap;

                let store = this.$store;
                this.markers.forEach((item) => {
                    const position = new google.maps.LatLng(
                        parseFloat(item.coordGeolocalisationLatitude),
                        parseFloat(item.coordGeolocalisationLongitude)
                    );

                    const marker = new google.maps.Marker({position, map, icon: '/bundles/site/img/colissimoMarker.png'});

                    const infoWindow = new google.maps.InfoWindow({
                        content: this.createInfoWindow(item),
                    });

                    this.gMapInfoWindows.push({id: item.identifiant, obj: infoWindow});

                    marker.addListener('click', function() {
                        infoWindow.open(map, marker);
                        store.commit(vm.storeSetColissimoPoint, item.identifiant);
                    });

                    map.fitBounds(bounds.extend(position));

                    this.gMarkers.push(marker);
                });

                this.gMap = map;
            },
            deleteMarkers() {
                for (var i = 0; i < this.gMarkers.length; i++) {
                    this.gMarkers[i].setMap(null);
                }

                this.gMarkers = [];
                this.gMapInfoWindows = [];

            },
            createInfoWindow(item) {
                let html = '<div>';
                html += '<span class="desc">';
                html += '<strong>'+item.nom+'</strong><br>';
                html += item.adresse1+'<br>';
                html += item.codePostal+' '+item.localite;
                html += '<br><br>';
                html += '<strong>Horaires:</strong> <br>';
                html += '<strong>Lundi:</strong> '+item.horairesOuvertureLundi+'<br>';
                html += '<strong>Mardi:</strong> '+item.horairesOuvertureMardi+'<br>';
                html += '<strong>Mercredi:</strong> '+item.horairesOuvertureMercredi+'<br>';
                html += '<strong>Jeudi:</strong> '+item.horairesOuvertureJeudi+'<br>';
                html += '<strong>Vendredi:</strong> '+item.horairesOuvertureVendredi+'<br>';
                html += '<strong>Samedi:</strong> '+item.horairesOuvertureSamedi+'<br>';
                html += '<strong>Dimanche:</strong> '+item.horairesOuvertureDimanche+'<br>';
                html += '</span>';
                html += '<div class="clearfix"></div>';
                html += '</div>';

                return html;
            }
        },
        watch: {
            markers() {
                this.setMarkers();
            },
            selectedMarker(value) {
                for(let j = 0; j < this.gMapInfoWindows.length; j++) {
                    if(value === this.gMapInfoWindows[j].id) {
                        this.gMapInfoWindows[j].obj.open(this.gMap, this.gMarkers[j]);
                    }
                    else {
                        this.gMapInfoWindows[j].obj.close();
                    }
                }
            }
        },
        mounted() {
            const element = document.getElementById(this.mapName);
            const options = {
                zoom: 14,
                center: new google.maps.LatLng(this.lat,this.lng)
            };
            const map = new google.maps.Map(element, options);
            this.gMap = map;

            this.setMarkers();
        }
    };

    export default GoogleMap;
</script>



// WEBPACK FOOTER //
// src/SiteBundle/Resources/assets/components/Order/GoogleMap.vue